export enum TemplatesTypes {
  Classic = "classic",
  Corporate = "corporate",
}

export type PageSizeType = "A4" | "A3" | "80mm";

export interface InvoiceTemplateContext {
  order: any;
  config: {
    store_name: string;
    address: string;
    phone: string;
    currency: string;
    receipt_footer: string;
    [key: string]: any;
  };
  pageSize: PageSizeType;
  isForPrint: boolean;
  fmt: (val: any) => string;
}
